export default __webpack_public_path__ + "static/media/place_holder_offer.ddbef339.svg";